import React from "react";
import styles from "./CorporateSocial.module.scss";
import PdfFileImg from "../../../assets/images/PdfFileImg.jpg";
import SocialImg from "../../../assets/images/SocialImg1.png";
import SocialImg2 from "../../../assets/images/SocialImg2.png";
import SocialImg3 from "../../../assets/images/SocialImg3.png";
import SocialImg4 from "../../../assets/images/SocialImg4.png";
import SocialImg5 from "../../../assets/images/SocialImg5.png";
import SocialImg6 from "../../../assets/images/SocialImg6.png";
import SocialImg7 from "../../../assets/images/SocialImg7.png";
import BreadCrumb from "../../CommonComponents/BreadCrumb.tsx";
import { motion } from "framer-motion";

const CorporateSocial: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "About Us", link: "/about-us" },
    { title: "Corporate Social Responsibility", link: "" },
  ];
  return (
    <div id="CorporateSocial" className={styles.corporateSocial}>
      <BreadCrumb menu={breadcrumb} />
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <CorporateSection />
        </motion.div>
      </div>
    </div>
  );
};
const CorporateSection = () => {
  return (
    <div className="section">
      <div className="row mb-5">
        <div className="col-md-12 col-lg-8 col-sm-12">
          <div className="mt-5">
            <p className="heading">Corporate Social Responsibility </p>
            <div className={` pt-2 ${styles.contentSection}`}>
              <p className="para">
                As a leading <a href="/our-businesses/domestic-retail">vocational training provider</a>,
                <a href="/"> Aptech</a> is dedicated to empowering
                underprivileged youth by offering free <a href="/our-businesses/international-retail">computer, animation, and
                skill-based training</a> at centres across the country.
              </p>
              <p className="para">
                By focusing on developing essential skills, Aptech not only
                enhances these students' capabilities, but also improves
                employability in the country, thereby contributing to a brighter
                future for young minds from the underserved communities.
              </p>
            </div>

            <div
              className={`d-flex justify-content-start align-items-center ${styles.CSRPolicyButton}`}
            >
              <p className={`para mb-0 ${styles.viewText}`}>
                Click here to view
              </p>

              <a
                href="https://www.aptech-worldwide.com/downloads/policy-on-corporate-social-responsibility-v5-1.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className={`d-flex justify-content-center align-items-center secondary-btn ${styles.CsrPolicyLabelDiv}`}
              >
                <div className="d-flex align-items-center">
                  <img src={PdfFileImg} alt="PdfFileImg" />
                  <p className={`mb-0 ${styles.CsrPolicyLabel}`}>
                    Aptech's CSR Policy
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className={`col-md-12 col-lg-4 col-sm-12 ${styles.imageOuterDiv}`}>
          <div className={styles.backgroundContainer}>
            <div className={`d-flex justify-content-center`}>
              <img
                src={SocialImg}
                alt="SocialImg"
                className={styles.socialImage}
              />
            </div>

            <div
              className={`d-flex justify-content-center ${styles.secondRow}`}
            >
              <img
                src={SocialImg2}
                alt="SocialImg2"
                className={styles.socialImage}
              />

              <img
                src={SocialImg3}
                alt="SocialImg3"
                className={styles.socialImage}
              />
            </div>

            <div className={styles.thirdRow}>
              <img
                src={SocialImg5}
                alt="SocialImg5"
                className={styles.socialImage}
              />

              <img
                src={SocialImg4}
                alt="SocialImg4"
                className={styles.socialImage}
              />
            </div>

            <div
              className={`d-flex justify-content-center ${styles.fourthRow}`}
            >
              <img
                src={SocialImg6}
                alt="SocialImg6"
                className={styles.socialImage}
              />

              <img
                src={SocialImg7}
                alt="SocialImg7"
                className={styles.socialImage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CorporateSocial;
